/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Career_0Inputs */

const en_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead instructor, Des Moines Golf & Country Club (1979)`)
};

const es_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructor principal, Des Moines Golf & Country Club (1979)`)
};

const de_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leitender Ausbilder, Des Moines Golf & Country Club (1979)`)
};

const zh_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`得梅因高尔夫乡村俱乐部首席教练 (1979)`)
};

const ar_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدرب رئيسي، Des Moines Golf & Country Club (1979)`)
};

const fr_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructeur principal, Des Moines Golf & Country Club (1979)`)
};

const vi_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huấn luyện viên chính, Des Moines Golf & Country Club (1979)`)
};

const sw_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mkufunzi mkuu, Des Moines Golf & Country Club (1979)`)
};

const th_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้ฝึกสอนหลัก สนามกอล์ฟ Des Moines Golf & Country Club (1979)`)
};

const bs_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glavni instruktor, Des Moines Golf & Country Club (1979)`)
};

const ja_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リードインストラクター、デモイン・ゴルフ＆カントリークラブ（1979年）`)
};

const ko_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수석 강사, Des Moines 골프 & 컨트리 클럽 (1979)`)
};

const pt_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrutor principal, Des Moines Golf & Country Club (1979)`)
};

const it_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istruttore principale, Des Moines Golf & Country Club (1979)`)
};

const sv_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huvudinstruktör, Des Moines Golf & Country Club (1979)`)
};

const nl_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoofdinstructeur, Des Moines Golf & Country Club (1979)`)
};

const da_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ledende instruktør, Des Moines Golf & Country Club (1979)`)
};

const nb_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ledende instruktør, Des Moines Golf & Country Club (1979)`)
};

const fi_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Johtava ohjaaja, Des Moines Golf & Country Club (1979)`)
};

const pl_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruktor wiodący, Des Moines Golf & Country Club (1979)`)
};

const ru_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Главный инструктор, Des Moines Golf & Country Club (1979)`)
};

const tr_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baş eğitmen, Des Moines Golf & Country Club (1979)`)
};

const hi_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुख्य प्रशिक्षक, Des Moines Golf & Country Club (1979)`)
};

const id_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruktur utama, Des Moines Golf & Country Club (1979)`)
};

const ms_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jurulatih utama, Des Moines Golf & Country Club (1979)`)
};

const cs_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hlavní instruktor, Des Moines Golf & Country Club (1979)`)
};

const el_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επικεφαλής εκπαιδευτής, Des Moines Golf & Country Club (1979)`)
};

const he_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מדריך ראשי, Des Moines Golf & Country Club (1979)`)
};

const af_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoofinstrukteur, Des Moines Golf & Country Club (1979)`)
};

const hu_about_content_career_0 = /** @type {(inputs: About_Content_Career_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vezető oktató, Des Moines Golf & Country Club (1979)`)
};

/**
* | output |
* | --- |
* | "Lead instructor, Des Moines Golf & Country Club (1979)" |
*
* @param {About_Content_Career_0Inputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_career_0 = /** @type {((inputs?: About_Content_Career_0Inputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Career_0Inputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_career_0(inputs)
	if (locale === "de") return de_about_content_career_0(inputs)
	if (locale === "zh") return zh_about_content_career_0(inputs)
	if (locale === "ar") return ar_about_content_career_0(inputs)
	if (locale === "fr") return fr_about_content_career_0(inputs)
	if (locale === "vi") return vi_about_content_career_0(inputs)
	if (locale === "sw") return sw_about_content_career_0(inputs)
	if (locale === "th") return th_about_content_career_0(inputs)
	if (locale === "bs") return bs_about_content_career_0(inputs)
	if (locale === "ja") return ja_about_content_career_0(inputs)
	if (locale === "ko") return ko_about_content_career_0(inputs)
	if (locale === "pt") return pt_about_content_career_0(inputs)
	if (locale === "it") return it_about_content_career_0(inputs)
	if (locale === "sv") return sv_about_content_career_0(inputs)
	if (locale === "nl") return nl_about_content_career_0(inputs)
	if (locale === "da") return da_about_content_career_0(inputs)
	if (locale === "nb") return nb_about_content_career_0(inputs)
	if (locale === "fi") return fi_about_content_career_0(inputs)
	if (locale === "pl") return pl_about_content_career_0(inputs)
	if (locale === "ru") return ru_about_content_career_0(inputs)
	if (locale === "tr") return tr_about_content_career_0(inputs)
	if (locale === "hi") return hi_about_content_career_0(inputs)
	if (locale === "id") return id_about_content_career_0(inputs)
	if (locale === "ms") return ms_about_content_career_0(inputs)
	if (locale === "cs") return cs_about_content_career_0(inputs)
	if (locale === "el") return el_about_content_career_0(inputs)
	if (locale === "he") return he_about_content_career_0(inputs)
	if (locale === "af") return af_about_content_career_0(inputs)
	if (locale === "hu") return hu_about_content_career_0(inputs)
	return en_about_content_career_0(inputs)
});